<template>
  <div class="not-found-page">
    <section class="not-found-hero" aria-labelledby="not-found-title">
      <div class="not-found-inner">
        <p class="eyebrow">404</p>
        <h1 id="not-found-title">页面未找到</h1>
        <p>
          该页面可能已调整或链接输入有误。你可以返回首页，查看精装入场查验、过程质量巡检、分户查验、工程质量检测和整改复查等服务内容。
        </p>
        <div class="actions">
          <router-link class="btn btn-primary" to="/">返回首页</router-link>
          <router-link class="btn btn-secondary" to="/services">查看对公服务</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { breadcrumbSchema, setSeo, setStructuredData } from "../utils/seo";

export default {
  name: "NotFound",
  mounted() {
    setSeo({
      title: "页面未找到｜江苏道鼎升工程检测",
      description: "页面未找到。返回江苏道鼎升工程检测有限公司首页，了解精装入场查验、过程质量巡检、分户查验、一房一验、工程质量检测和整改复查服务。",
      path: this.$route.path,
      robots: "noindex,follow"
    });
    setStructuredData([
      breadcrumbSchema([
        { name: "首页", path: "/" },
        { name: "页面未找到", path: this.$route.path }
      ])
    ]);
  }
};
</script>

<style lang="scss" scoped>
.not-found-page {
  min-height: calc(100vh - 64px);
  background: #f5f8f7;
  color: #1f2d3d;
}

.not-found-hero {
  min-height: 520px;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #0f4c5c, #18736e);
}

.not-found-inner {
  width: min(860px, calc(100% - 48px));
  margin: 0 auto;
  color: #fff;
}

.eyebrow {
  color: #f1b24a;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 12px;
}

h1 {
  font-size: 42px;
  line-height: 1.25;
  margin: 0 0 18px;
}

p {
  max-width: 720px;
  color: rgba(255, 255, 255, 0.88);
  font-size: 17px;
  line-height: 1.9;
  margin: 0;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 30px;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 0 22px;
  border-radius: 4px;
  color: #fff;
  text-decoration: none;
}

.btn-primary {
  background: #d76b30;
}

.btn-secondary {
  border: 1px solid rgba(255, 255, 255, 0.72);
}

@media (max-width: 640px) {
  .not-found-inner {
    width: min(100% - 28px, 860px);
  }

  h1 {
    font-size: 30px;
  }

  .btn {
    width: 100%;
  }
}
</style>
